import { PureComponent } from "react";

interface IProps {
    input: any;
    id: string;
}

export default class HiddenInput extends PureComponent<IProps> {
    render() {
        const { id } = this.props;

        return (
            <>
                <input {...this.props.input} id={id} type="hidden" />
            </>
        );
    }
}
